// US-style number formatting. Used across the player PWA so numbers like
// 1300 render as "1,300". Decimals (e.g. SMRT Index 47.31) are preserved.
const usFormatter = new Intl.NumberFormat('en-US');
const usDecimalFormatter = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 1,
  maximumFractionDigits: 2,
});

export const formatNumber = (value) => {
  if (value == null || value === '') return '';
  const num = typeof value === 'number' ? value : Number(value);
  if (!Number.isFinite(num)) return String(value);
  if (!Number.isInteger(num)) return usDecimalFormatter.format(num);
  return usFormatter.format(num);
};
